export const shoppingCartKey = 'shoppingCartId'
